/* eslint-disable import/no-unresolved */
import React from 'react';
import { render } from '@wordpress/element';
import './index.scss';
import Map from './components/Map';
// import SortedTable from './components/SortedTable';
import Tables from './components/Table';

import Source from './components/Source';
import { UserProvider } from './context/context';

const IntermarriageMap = () => {
    return (
        <UserProvider>
            <p id="intro">
                The share of newlyweds married to someone of a different race or
                ethnicity has been steadily climbing in the United States. In
                1967, 3% of newlyweds were intermarried, and by 2015, that share
                had risen to 17%. Across metropolitan areas, intermarriage rates
                vary dramatically. Honolulu has the highest rate of
                intermarriage – 42% of newlyweds have a spouse of a different
                race or ethnicity. On the other hand, in Jackson, Mississippi,
                and Asheville, North Carolina, just 3% of the recently wed are
                intermarried. As is the case nationally, within metro areas,
                intermarriage rates differ across races. For instance, among
                newlyweds in Chicago, 35% of Asians are married to someone of a
                different race or ethnicity, compared with 24% of Hispanics, 14%
                of whites and 13% of blacks.
            </p>
            <Map />
            <Tables />
            <Source />
        </UserProvider>
    );
};

if (document.getElementById('js-intermarriage-map')) {
    render(
        <IntermarriageMap />,
        document.getElementById('js-intermarriage-map'),
    );
}
